import { g } from "@/config/global";
import i18n from "@/i18n";

/**
 * API 응답의 성공 여부를 확인하고 에러 메시지를 표시하는 함수
 * @param {Object} response - API 응답 데이터
 * @param {string} successMessage - 성공 시 표시할 메시지 (선택사항)
 * @returns {boolean} 성공 여부
 */
const handleApiResponse = (response, successMessage = null) => {
  const { success, error, message } = response;
  
  if (success) {
    if (successMessage) {
      g.globalProperties.$swal.success({
        title: successMessage,
      });
    }
    return true;
  }
  
  g.globalProperties.$swal.error({
    title: i18n.global.t(error || ""),
    text: i18n.global.t(message || ""),
  });
  return false;
};

/**
 * API 에러를 처리하는 함수
 * @param {Error} error - 발생한 에러 객체
 */
const handleApiError = (error) => {
  g.globalProperties.$swal.error({
    title: i18n.global.t(error?.response?.data?.error || error.message),
    text: i18n.global.t(
      typeof error?.response?.data?.message === "string"
        ? error?.response?.data?.message
        : ""
    ),
  });
};

/**
 * API 호출을 실행하고 결과를 처리하는 함수
 * @param {Function} apiCall - API 호출 함수
 * @param {string} successMessage - 성공 시 표시할 메시지 (선택사항)
 * @returns {Promise<Object|null>} API 응답 데이터 또는 null
 */
export const executeApiCall = async (apiCall, successMessage = null) => {
  try {
    const response = await apiCall();
    if (handleApiResponse(response.data, successMessage)) {
      return response.data;
    }
    return null;
  } catch (error) {
    handleApiError(error);
    return null;
  }
}; 